module.exports = "<div class=\"basler-select-box\">\n    <ng-transclude></ng-transclude>\n    <div\n        ng-if=\"showArrow() !== false\"\n        class=\"basler-select-box__arrow\"\n        ng-include=\"'/qnb/styles/images/icons/icon-nav-dropdown.svg'\"\n    ></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ../common/grunt/webpack/loaders/text-loader!../common/js/src/edge/platform/basler/templates/basler-select-box.html
// module id = 590
// module chunks = 0